import { render, staticRenderFns } from "./DocumentPortalSetupChecklistView.vue?vue&type=template&id=cfcf2b9a&scoped=true&"
import script from "./DocumentPortalSetupChecklistView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalSetupChecklistView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalSetupChecklistView.vue?vue&type=style&index=0&id=cfcf2b9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcf2b9a",
  null
  
)

export default component.exports